import { Card, Divider, Grid, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import FieldContainer from '../../../FormFields/FieldContainer';
import FormButtonOptions from '../../../FormFields/FormButtonOptions';
import FormMoneyField from '../../../FormFields/FormMoneyField';
import FormTitle from '../../../FormFields/FormTitle';
import FormVendorField from '../../../FormFields/FormVendorField';
import { formCardStyle } from '../../../TransitionStyles';
import { FILE_TYPES } from '../../../formFileTypesEnum';
import { OPERATIONS } from '../../../formQuestionsEnum';

CorporateComplianceForm.propTypes = {
  permissions: PropTypes.object,
};

export default function CorporateComplianceForm({ permissions }) {
  const { watch } = useFormContext();
  const isContracted = watch(OPERATIONS.CORPORATE_COMPLIANCE_IS_CONTRACTED.fieldName);
  const [focusedField, setFocusedField] = useState(null);

  const fieldIds = [
    OPERATIONS.CORPORATE_COMPLIANCE_IS_CONTRACTED.id,
    OPERATIONS.CORPORATE_COMPLIANCE_VENDOR.id,
    OPERATIONS.CORPORATE_COMPLIANCE_MONTHLY_CHARGE.id,
  ];

  const showForm = fieldIds.some((id) => id in permissions);

  return (
    showForm && (
      <Card sx={formCardStyle}>
        <Typography sx={{ mb: 1 }} align="center" variant="body1" color="info.main">
          Corporate Compliance
        </Typography>
        <Divider sx={{ mb: 1, mt: 2, borderWidth: 1 }} />
        <Grid container spacing={1.5}>
          {OPERATIONS.CORPORATE_COMPLIANCE_IS_CONTRACTED.id in permissions && (
            <Grid item xs={12}>
              <FieldContainer>
                <FormTitle fieldAttributes={{ questionTitle: 'Choose one' }} />
                <FormButtonOptions
                  fieldName={OPERATIONS.CORPORATE_COMPLIANCE_IS_CONTRACTED.fieldName}
                  fieldAttributes={{
                    isEditable: permissions[OPERATIONS.CORPORATE_COMPLIANCE_IS_CONTRACTED.id],
                    options: [
                      { label: 'In-house', value: false },
                      { label: 'Contracted', value: true },
                    ],
                  }}
                />
              </FieldContainer>
            </Grid>
          )}
          {isContracted === true && (
            <>
              {OPERATIONS.CORPORATE_COMPLIANCE_VENDOR.id in permissions && (
                <Grid item xs={12}>
                  <FormTitle fieldAttributes={{ questionTitle: 'Corporate compliance vendor', fieldType: 'title' }} />

                  <FormVendorField
                    fieldName={OPERATIONS.CORPORATE_COMPLIANCE_VENDOR.fieldName}
                    fieldAttributes={{ isEditable: permissions[OPERATIONS.CORPORATE_COMPLIANCE_VENDOR.id] }}
                    invoiceFileTypeId={FILE_TYPES.CORPORATE_COMPLIANCE_VENDOR_INVOICE}
                    contractFileTypeId={FILE_TYPES.CORPORATE_COMPLIANCE_VENDOR_CONTRACT}
                  />
                </Grid>
              )}
              {OPERATIONS.CORPORATE_COMPLIANCE_MONTHLY_CHARGE.id in permissions && (
                <Grid item xs={12} sm={6}>
                  <FormTitle fieldAttributes={{ questionTitle: 'Monthly charge' }} />
                  <FormMoneyField
                    fieldName={OPERATIONS.CORPORATE_COMPLIANCE_MONTHLY_CHARGE.fieldName}
                    fieldAttributes={{
                      isEditable: permissions[OPERATIONS.CORPORATE_COMPLIANCE_MONTHLY_CHARGE.id],
                    }}
                    focusedField={focusedField}
                    setFocusedField={setFocusedField}
                  />
                </Grid>
              )}
            </>
          )}
        </Grid>
      </Card>
    )
  );
}
